import { render, staticRenderFns } from "./AddCourseInfo.vue?vue&type=template&id=73dbc2a3&"
import script from "./AddCourseInfo.vue?vue&type=script&lang=ts&"
export * from "./AddCourseInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports